export function hexToRgba(hex: string, alpha: number): string {
    const normalized = hex.replace("#", "");
    const value =
        normalized.length === 3
            ? normalized
                  .split("")
                  .map((char) => char + char)
                  .join("")
            : normalized;

    const red = parseInt(value.slice(0, 2), 16);
    const green = parseInt(value.slice(2, 4), 16);
    const blue = parseInt(value.slice(4, 6), 16);

    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}

export function darkenHex(hex: string, factor: number): string {
    const normalized = hex.replace("#", "");
    const value =
        normalized.length === 3
            ? normalized
                  .split("")
                  .map((char) => char + char)
                  .join("")
            : normalized;

    const scale = (offset: number) =>
        Math.max(0, Math.min(255, Math.round(parseInt(value.slice(offset, offset + 2), 16) * factor)))
            .toString(16)
            .padStart(2, "0");

    return `#${scale(0)}${scale(2)}${scale(4)}`;
}
